import { CSSObject } from '@chakra-ui/react';
import { TLinkContainer } from './NextToJumpItem.styles';

export const LinkContainer = ({ isLast }: TLinkContainer) => ({
  borderBottom: !isLast && '1px dashed',
  borderBottomColor: 'blackAlpha.300',
  borderRadius: 'unset',
  px: '0',
  py: '2',
  mb: 'unset',
  mx: '2',
  w: 'auto',
  mt: '-0.5',
  bg: 'transparent',
  _hover: {
    bg: 'blackAlpha.100',
  },
});

export const BoxNextToJumpContainer: CSSObject = {
  bg: 'white',
  borderWidth: '2px',
  borderColor: 'beta.400',
  mx: ['2', '4'],
  borderRadius: 'md',
  boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.35)',
};

export const Icon: CSSObject = {
  boxSize: '9',
  color: 'alpha.600',
  bgGradient: 'linear(180deg, gamma.400, gamma.600)',
  boxShadow:
    '0px 0px 0px 3px #275563 inset, 0px 1px 2px 0px rgba(0, 0, 0, 0.40)',
  borderWidth: '3px',
  borderColor: 'gamma.400',
  borderRadius: 'lg',
  p: '1',
  mr: '2',
};

export const TextRace: CSSObject = {
  color: 'alpha.700',
  fontFamily: 'Roboto',
  fontSize: 'xs',
  fontStyle: 'normal',
  lineHeight: 'normal',
  fontWeight: 'medium',
};

export const TextNumber: CSSObject = {
  // @TODO Clarify with designers or include in colors.ts
  bg: '#224049',
  color: 'white',
  h: '4',
  py: '0',
  pt: '0.5',
  borderRadius: 'base',
};

export const BoxHeading: CSSObject = {
  display: 'none',
  border: 'none',
};

export const FlexWrapper: CSSObject = {
  '.state-inprogress': {
    color: ['white', 'beta.900'],
  },
  '.chakra-badge': {
    borderRadius: 'sm',
    h: '4',
    minH: '4',
    py: '0',
    mr: '0.5',
    color: 'alpha.800',
  },
};
